import styled from '@emotion/styled';
import { EXEMPLAR_FOCUS, COLORS } from '../../constants';

export const StyledNote = styled.textarea`
  resize: none;
  min-height: 36px;
  width: 192px;
  height: 200px;
  margin: 0;
  background-color: ${COLORS.white};
  font-family: Mulish;
  font-size: 14px;
  border: none;
  border-radius: 0;
  padding: 8px;
  box-sizing: border-box;
  ${EXEMPLAR_FOCUS}
  resize: none;
  z-index: 42;
  &::placeholder {
    color: ${COLORS.black};
    opacity: 0.2;
  }
`;
